module.exports = __webpack_public_path__ + "static/media/ico_dashboard.ef336a92.svg";